export const NO_DISCOUNT_DATA_SELECTED =
  "Informe os valores do desconto antes de continuar ou clique em voltar";
export const ORDER_WITH_FULL_PAYMENTS = "Todo o valor do pedido já foi pago";
